var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"price-text"},[_c('div',{style:(_vm.flagSize)},[_vm._v("￥")]),_c('div',{staticClass:"font-bold",style:({ fontSize: `${_vm.highSize}px` })},[_vm._v(_vm._s(_vm.prices[0]))]),(_vm.prices[1])?_c('div',{style:(_vm.flagSize)},[_vm._v("."+_vm._s(_vm.prices[1]))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }